import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '@components/ui/Header';
import Footer from '@components/ui/Footer';
import PageHeader from './components/PageHeader';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';

const FAQsPage = () => {
  return (
    <>
      <Helmet>
        <title>FAQs - EyeU Kenya | Common Questions About Eye Care Services</title>
        <meta name="description" content="Find answers to frequently asked questions about Eye&U Kenya's eye care services, appointments, treatments, and insurance coverage." />
        <meta name="keywords" content="eye care FAQs, ophthalmologist questions, appointment booking, Kenya, eye doctor, vision care, eye examination, insurance" />
        <meta property="og:title" content="FAQs - EyeU Kenya" />
        <meta property="og:description" content="Find answers to frequently asked questions about Eye&U Kenya's eye care services and appointments." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FAQs - EyeU Kenya" />
        <meta name="twitter:description" content="Find answers to frequently asked questions about Eye&U Kenya's eye care services." />
        <link rel="canonical" href="https://eyenu.com/fa-qs-page" />
      </Helmet>

      <div className="min-h-screen bg-background flex flex-col">
        <Header />
        
        <main className="flex-1">
          <PageHeader />
          
          <section className="py-12 md:py-16">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <FAQSection />
            </div>
          </section>

          <ContactSection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default FAQsPage;